<template lang="pug">
  div
    slot
</template>

<script>
export default {
  provide () {
    return {
      checkboxGroupValueArray: this.value,
      updateCheckboxGroupValueArray: this.updateCheckboxGroupValueArray,
    };
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateCheckboxGroupValueArray (checkboxValue) {
      const array = this.value;
      const index = this.value.indexOf(checkboxValue);
      index === -1 ? array.push(checkboxValue) : array.splice(index, 1);
      this.$emit('input', array);
    },
  },
};
</script>
